import { StyleSheet, Text, View } from './components/base_components';
import BusyComponent from './components/busy_component';

import UserStore from './stores/user_store';

import ModalDialog from './components/dialogs/modal_dialog';
import WideButton from './components/buttons/wide_button';

const styles = StyleSheet.create({
  loginScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    margin: '2em',
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  button: {
    marginTop: '5em',
  },
});

type Props = {};
type State = {};

export default class LoginScreen extends BusyComponent<Props, State> {
  componentDidMount() {
    if (UserStore.isLoggedIn()) {
      this.props.history.replace('/');
    }
  }

  _onFacebookLogin = () => {
    if (this.setBusy()) {
      UserStore.login(err => {
        this.clearBusy();
        if (err) {
          ModalDialog.error('Login Failed.');
        } else {
          ModalDialog.alert('Login Success.');
          this.props.history.replace('/');
        }
      });
    }
  };

  render() {
    return (
      <View style={styles.loginScreen}>
        <Text style={styles.text}>Login</Text>
        <WideButton
          style={styles.button}
          text='Facebook Login'
          onPress={this._onFacebookLogin}
        />
        <BusyComponent.BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
